module.exports = __webpack_public_path__ + "static/bimbo_waving-3337fc707f8fee257f031ad433dd0f91.png";